import React, { useState, useEffect } from "react";
import "./Loading.css";

const triple = elem =>
  // eslint-disable-next-line react/no-array-index-key
  [...new Array(3)].map((_, i) => React.cloneElement(elem, { key: i }))

export const LoadingTable = () => (
  <table className='table waiting-for-data is-fullwidth'>
    <thead>
      <tr>
        {triple(
          <th>
            <div />
          </th>
        )}
      </tr>
    </thead>
    <tbody>
      <tr>
        {triple(
          <td>
            <div />
          </td>
        )}
      </tr>
    </tbody>
  </table>
);

const LoadingIcon = () => (
  <svg
    className="loading-svg" // Esta clase ahora tiene la animación de zoom
    width="48"
    height="41"
    viewBox="0 0 38 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4441 0.5H0L12.4857 29.4015L17.6757 17.2597L10.4441 0.5Z"
      fill="#5ECADA"
    />
    <path
      d="M27.5557 0.5H37.9998L24.1506 32.5H13.9053L27.5557 0.5Z"
      fill="#AA6CC9"
    />
  </svg>
);

const Loading = () => {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loading-container">
      <LoadingIcon />
      <div className="loading-text">
        Esperando... 
        <>{seconds}</>
      </div>
    </div>
  );
};

export default Loading
